/**
 * HTTP 200 + ApiResponseMessage 형태의 비즈니스 오류 응답을 판별합니다.
 * 성공 응답에만 있는 code 필드는 오류 판별에 사용하지 않습니다.
 */
export function parseSampleApiBusinessError(res) {
  const raw = res && res.data;
  const body = raw && typeof raw === 'object' ? raw : {};
  const errCodeRaw = body.errorCode ?? body.error_code;
  const errMsgRaw = body.errorMessage ?? body.error_message;
  const errCode = errCodeRaw != null && errCodeRaw !== '' ? String(errCodeRaw).trim() : '';
  const errMsg = errMsgRaw != null && errMsgRaw !== '' ? String(errMsgRaw).trim() : '';
  const hasBusinessError = errCode !== '' || errMsg !== '';
  const isDupComposition = errCode.includes('DUP');
  return { hasBusinessError, errMsg, errCode, isDupComposition, body };
}

export function sampleApiBusinessErrorText(parsed) {
  const { errMsg, isDupComposition, body } = parsed;
  if (errMsg) return errMsg.replace(/\r?\n/g, '<br />');
  if (body.message) return String(body.message).replace(/\r?\n/g, '<br />');
  return isDupComposition ? '동일한 조성의 샘플 마스터가 이미 등록되어 있습니다.' : '요청을 처리할 수 없습니다.';
}
